import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  Alert
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import Select from "react-select"

const NewAdmin = props => {

  const history = useHistory();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [code, setCode] = React.useState('');
  const [username, setUsername] = useState('');
  const [selectedProperties, setSelectedProperties] = React.useState([]);
  const [selectedBlocks, setSelectedBlocks] = React.useState([]);
  const [status, setStatus] = React.useState(1);
  const [role, setRole] = React.useState(2);

  const [properties, setProperties] = React.useState([]);
  const [propertiesBare, setPropertiesBare] = React.useState([]);

  const [errors, setErrors] = React.useState([]);

  
  const [loading, setLoading] = React.useState(false);
  const [initializing, setInitializing] = React.useState(true);

  const fetchData = (id) => {
    setLoading(true);
      console.log('Fetching ', id);
      get(url.GET_ADMIN+'/'+id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setName(response.data.name);
        setEmail(response.data.email);
        setPhone(response.data.phone);
        setCode(response.data.emp_code);
        setUsername(response.data.username);
        setRole(response.data.role_id);

        if(response.data.role_id == 2) {
          if(response.data.properties && response.data.properties.length > 0) {
            setSelectedProperties(response.data.properties.map(g => ({label: g.name, value: g.id})))
          }
        }

        if(response.data.role_id == 3) {
          if(response.data.blocks && response.data.blocks.length > 0) {
            setSelectedBlocks(response.data.blocks.map(g => ({label: g.name, value: g.id})))
          }
        }
        
        setStatus(response.data.status);
        setLoading(false);
      }
      else {
        cogoToast.error('Could not fetch Admin data');
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  const init = () => {
    setInitializing(true);
      get(url.GET_NEW_ADMIN).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setProperties(response.data.properties);
        setPropertiesBare(response.data.properties_bare);
        setInitializing(false);
      }
      else {
        cogoToast.error('Could not fetch data');
        setInitializing(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });

  }


  const handleSubmit = () => {


    if(name == '') {
      cogoToast.error('Name is required');
      return;
    }
    if(role == '2' && (!selectedProperties || selectedProperties.length < 1)) {
      cogoToast.error('Please select at least one property');
      return;
    }
    if(role == '3' && (!selectedBlocks || selectedBlocks.length < 1)) {
      cogoToast.error('Please select at least one block');
      return;
    }

    let data = {
      id: props.match.params.id ? props.match.params.id : 'new',
      name: name,
      email: email,
      phone: phone,
      emp_code: code,
      role_id: role,
      username: username,
      property_ids: role == '2' ? selectedProperties.map(p => p.value) : [],
      block_ids: role == '3' ? selectedBlocks.map(b => b.value) : [],
      status: status,
    };

    console.log('data', data);

    setLoading(true);
    setErrors([]);
    post(url.POST_NEW_ADMIN, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        history.push('/admins/index');
        cogoToast.success('Admin '+ (props.match.params.id ? (props.match.params.id == 'new' ? 'added' : 'updated') : 'added') + ' successfully');
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };

  React.useEffect(()=>{
    init();

    // console.log(props.match.params.id);

    if(props.match.params.id && props.match.params.id !== 'new') {
      // setName(props.match.params.id.name);
      fetchData(props.match.params.id);
    }
  }, []);

  // const displayedBlocks = blocks.length < 1 ? [] : blocks.filter(b => property == null ? false : b.property_id == property.value);

  console.log(selectedProperties, selectedBlocks, role);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.match.params.id ? (props.match.params.id == 'new' ? 'Add New' : 'Edit') : 'Add New'} Add Admin | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">{props.match.params.id ? (props.match.params.id == 'new' ? 'New' : 'Edit') : 'New'} Admin</h3>
            <Link className="btn btn-secondary" to="/admins/index">Back</Link>
          </div>


          {errors.length > 0 &&
          <div className="mt-3 mb-5">
            {errors.map((error, errorIdx)=>(
              <Alert key={errorIdx} color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
              </Alert>
            ))}
          </div>
          }

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row mt-2">
                <div className="col">
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Name</label>
                    <div className="col-sm-9">
                      <input autoFocus type="text" className="form-control" id="name"  value={name} onChange={e=>{ setName(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">User Name</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" id="username"  value={username} onChange={e=>{ setUsername(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Email</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" id="email"  value={email} onChange={e=>{ setEmail(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Phone</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" id="phone"  value={phone} onChange={e=>{ setPhone(e.target.value); }} />
                    </div>
                  </div>

                  <div className="mt-5 mb-4 row">
                    <label htmlFor="status" className="col-sm-3 col-form-label">Role</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select one" 
                        value={role}
                        onChange={(e)=>{ setRole(e.target.value); }}
                        >
                        <option value="2">Property Manager</option>
                        <option value="3">Site Manager</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="property" className="col-sm-3 col-form-label">
                      {role == '2' ? 'Properties' :  'Blocks'}
                    </label>
                    <div className="col-sm-9">
                      <Select
                        classNamePrefix="select2-selection"
                        closeMenuOnSelect={false}
                        placeholder="Choose..."
                        title={role == '2' ? 'Properties' :  'Blocks'}
                        options={role == '2' ? propertiesBare : properties}
                        isMulti
                        value={role == '2' ? selectedProperties : selectedBlocks}
                        onChange={e => { 
                          if(role == '2') {
                            setSelectedProperties(e); 
                          }
                          else {
                            setSelectedBlocks(e); 
                          }
                        }}
                        
                        />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="status" className="col-sm-3 col-form-label">Status</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select one" 
                        value={status}
                        onChange={(e)=>{ setStatus(e.target.value); }}
                        >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>


     </Container>

    <div className="mb-4 container">
      <div className="d-flex justify-content-center">
        <button type="button" className="btn btn-primary me-2" onClick={()=>{ handleSubmit(); }}>Submit</button>
        <Link className="btn btn-light" to="/admins/index">Cancel</Link>
      </div>
    </div>
      </div>
    </React.Fragment>
  )
}

export default NewAdmin
